import React, { useContext, useEffect, useState } from 'react';
import "./viewPastMeetings.css";
import { contextData } from '../../../../../context/ContextProvider';
import { GET } from '../../../../Common/HttpMethods/HttpMethods';
import { Url } from '../../../../../constants/ApiUrlConstants';
import { useNavigate } from "react-router-dom"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import moment from 'moment';
import Select from 'react-select';
import { BsDownload } from 'react-icons/bs'
import { useLocation } from 'react-router';
import FailModal from '../../../../Common/Popups/FailModal';
import { GeneratePDF, customStyles, stripHtmlTags } from '../../../../CommonCase/CommonFunctions';
export const handleSessionExpClose = (navigate,setActive) => {
        sessionStorage.clear();
        navigate('/login');
        setActive('tab1');
    }

export const handleMomVersionChange = async (
    e,
    setCurrentMomV,
    setPreviousMomV,
    setLoading,
    GET,
    Url,
    viewPastMeeting,
    token,
    setViewdata,
    setEmailDetails,
    setActions,
    setSessionExpiredModal,
    setFailMessage,
    previousMomV
) => {
    try {
        if (e.value !== previousMomV) {
            setCurrentMomV(e);
            setPreviousMomV(e.value);
            setLoading(true);

            let version = e.value;

            const meetingResponse = await GET(
                Url.getMomByVersion
                    .replace('{meetingId}', `${viewPastMeeting?.meetingId}`)
                    .replace('{version}', `${version}`)
                    .replace("{isAttendeeRequired}", "Y"),
                token
            );

            if (meetingResponse.SUCCESS) {
                setViewdata(meetingResponse.DATA);
                let AttendeesList = '', ApologiesList = '';
                const attendees = meetingResponse?.DATA?.emailDetail?.filter(i => i?.isAttendee === "Y");
                const apologies = meetingResponse?.DATA?.emailDetail?.filter(i => i?.isAttendee == "N");

                AttendeesList = attendees?.map(i => i?.employeeMaster?.fullName).join(", ");
                ApologiesList = apologies?.map(i => i?.employeeMaster?.fullName).join(", ");

                setEmailDetails({ AttendeesList, ApologiesList });
                setActions(meetingResponse.DATA.actionItems);
                setLoading(false);
            } else if (meetingResponse?.STATUS == 401) {
                setLoading(false);
                setSessionExpiredModal(true);
                setFailMessage("Session expired");
            }else if (meetingResponse?.STATUS === 400) {
                setSessionExpiredModal(true)
                setFailMessage("The request was invalid.")
              }else if (meetingResponse?.STATUS === 403) {
                setSessionExpiredModal(true)
                setFailMessage("You do not have access.")
              }else if (meetingResponse?.STATUS === 404) {
                setSessionExpiredModal(true)
                setFailMessage("The resource could not be found.")
              }else if (meetingResponse?.STATUS === 500) {
                setSessionExpiredModal(true)
                setFailMessage("Something went wrong on the server")
              } else {
                setLoading(false);
            }
        } else {
           // console.log("Same version selected. Skipping API call.");
        }
    } catch (error) {
        setLoading(false);
      //  console.error("Error fetching version data:", error);
    }
};

export const transformText = (text) => {
    return text.split('\n').join('<br/>');
};


const ViewPastMeetings = () => {

    const token = sessionStorage.getItem("TOKEN");

    const { viewPastMeeting, setViewPastMeeting, setLoading, setActive } = useContext(contextData);
    const [viewdata, setViewdata] = useState({})
    const [emailDetails, setEmailDetails] = useState();
    const [sessionExpiredModal, setSessionExpiredModal] = useState(false)
    const [actions, setActions] = useState([]);
    const [failMessage, setFailMessage] = useState("");
    const [allVersionsMomData, setAllVersionsMomData] = useState();
    const [versionOpt, setVersionOpt] = useState([]);
    const [currentMomV, setCurrentMomV] = useState()
    const [previousMomV, setPreviousMomV] = useState(null);

    const navigate = useNavigate()
   
    useEffect(() => {
        setCurrentMomV(versionOpt[0])
    }, [versionOpt])


    const getMeetingDataPrev = async () => {

        try {
            setLoading(true);
            const meetingResponse = await GET(Url.GetMeetingMomByMeetingId.replace('{meetingId}', `${viewPastMeeting?.meetingId}`).replace("{isAttendeeRequired}", "Y"), token);

            if (meetingResponse.SUCCESS) {

                setViewdata(meetingResponse?.DATA);
                let AttendeesList = '', ApologiesList = '';

                const attendees = meetingResponse?.DATA?.emailDetail?.filter(i => i?.isAttendee === "Y");

                const apologies = meetingResponse?.DATA?.emailDetail?.filter(i => i?.isAttendee == "N");

                AttendeesList = attendees?.map(i => i?.employeeMaster?.fullName).join(", ");

                ApologiesList = apologies?.map(i => i?.employeeMaster?.fullName).join(", ");

                setEmailDetails({ AttendeesList, ApologiesList })
                setActions(meetingResponse?.DATA?.actionItems || []);
                setLoading(false);
            }
            else if (meetingResponse?.STATUS == 401) {
                setLoading(false)
                setSessionExpiredModal(true)
                setFailMessage("Session expired")
            }else if (meetingResponse?.STATUS == 404) {
                setLoading(false)
            }else if (meetingResponse?.STATUS == 500) {
                setLoading(false)
            }else if (meetingResponse?.STATUS == 400) {
                setLoading(false)
            }else if (meetingResponse?.STATUS == 403) {
                setLoading(false)
            }
            else {
                // alert('failed to fetch');
                setLoading(false);
            }
        }
        catch (error) {
            setLoading(false);
        }
    }
    const getMomVersionsListFun = async () => {

        try {
            setLoading(true);
            const meetingResponse = await GET(Url.getMomVersionsList.replace('{mid}', `${viewPastMeeting?.meetingId}`), token);

            if (meetingResponse.SUCCESS) {

                let opt = [];

                for (let i = 0; i < meetingResponse?.DATA?.length; i++) {
                    opt.push({ label: meetingResponse.DATA[i], value: meetingResponse.DATA[i] });
                }

                setVersionOpt(opt)
                setLoading(false);
            }
            else if (meetingResponse?.STATUS == 401) {
                setLoading(false)
                setSessionExpiredModal(true)
                setFailMessage("Session expired")
            }
            else {
                alert('failed to fetch Mom version list');
                setLoading(false);
            }
        }
        catch (error) {
            setLoading(false);
        }
    }

    

    useEffect(() => {
        getMomVersionsListFun();
        // getMeetingDataAllVersion();
        getMeetingDataPrev();
    }, []);

    useEffect(() => {
        return () => {
            setViewPastMeeting({ ...viewPastMeeting, isView: false })
        }
    }, [])



    // const handleVersionChange = async () => {

    //     try {
    //         setLoading(true);
    //         const meetingResponse = await GET(Url.getMomVersionsList.replace('{mid}', `${viewPastMeeting?.meetingId}`), token);

    //         if (meetingResponse.SUCCESS) {

    //             // setVersionOpt(meetingResponse.DATA)
    //             for (let i = 0; i < meetingResponse.DATA.length; i++) {
    //                 setVersionOpt([...versionOpt, { value: meetingResponse.DATA[i], label: meetingResponse.DATA[i] }])

    //             }

    //             setLoading(false);
    //         }
    //         else if (meetingResponse?.STATUS == 401) {
    //             setLoading(false)
    //             setSessionExpiredModal(true)
    //             setFailMessage("Session expired")
    //         }
    //         else {
    //             alert('failed to fetch Mom version list');
    //             setLoading(false);
    //         }
    //     }
    //     catch (error) {
    //         setLoading(false);
    //     }
    // }


    const handleMomVersionChangeWrapper = (e) => {
        handleMomVersionChange(
            e,
            setCurrentMomV,
            setPreviousMomV,
            setLoading,
            GET,
            Url,
            viewPastMeeting,
            token,
            setViewdata,
            setEmailDetails,
            setActions,
            setSessionExpiredModal,
            setFailMessage,
            previousMomV
        );
    };

    return (
        <div className="view-past-meeting-main">
            <div className="view-meeting-header">
                <div className='VPM-select-Version-Dropdown'>
                    <div
                    //  style={{color:'#383838'}}
                    >Select Version :</div>
                    <Select
                        isSearchable={false}
                        options={versionOpt}
                        styles={customStyles}
                        value={currentMomV}
                        onChange={handleMomVersionChangeWrapper}
                    />
                </div>
                <h4>Minutes Of Meeting</h4>
                <div className="download-btn" data-testid="GeneratePDF" onClick={() => GeneratePDF(viewPastMeeting?.meetingId, currentMomV?.value)}>
                    <BsDownload fill='white' size={14} />
                    <span style={{ color: "white", fontWeight: '500', fontSize: 14 }}>Download PDF</span>
                </div>
            </div>
            <div className="view-meeting-table-container" id='capture'>
                <table className='tableToExport' >
                    <tr className='first-row row' style={{ minHeight: '6vh', marginBottom: "5px" }}>
                        <td className='left-column'><p>Meeting Name</p></td>
                        <td className='right-column' style={{ fontWeight: "500", }}><p style={{ padding: "3px 5px", fontSize: "14px" }} className='VPM-M-namevalue'>{viewdata?.meetingSubject}</p></td>
                    </tr>
                    <tr className='second-row row' style={{ minHeight: '7vh', paddingBottom: '30px' }}>
                        <td className='left-column'>
                            <p>Date</p>
                        </td>
                        <td className='date-row'>
                            <div className="date-item view-PM-border-style" style={{ width: "20%" }}><span>{viewdata?.startDate && `${viewdata?.startDate[2]}/${viewdata?.startDate[1]}/${viewdata?.startDate[0]}`}</span></div>
                            <div className="date-item view-PM-border-style" style={{ width: "35%" }}>
                                <label htmlFor="">Starts From</label>  <span>{viewdata?.startTime}</span>
                            </div>
                            <div className="date-item view-PM-border-style" style={{ width: "45%" }}>
                                <label htmlFor="">Recorded By</label>    <span>{viewdata?.momRecordedBy?.fullName ? viewdata?.momRecordedBy?.fullName : ""}</span>
                            </div>

                        </td>
                    </tr>

                    <tr className='second-row row' style={{ minHeight: '8vh' }}>
                        <td className='left-column' style={{ paddingTop: '2px' }}>
                            <p>Duration</p>
                        </td>
                        <td className='date-row'>
                            <div className="date-item view-PM-border-style" style={{ width: "20%" }}><span>{viewdata?.duration}</span></div>
                            <div className="date-item view-PM-border-style" style={{ width: "35%" }}>
                                <label htmlFor="">End On</label>  <span> {viewdata?.endTime === "11:59 PM" ? "12:00 AM" : viewdata?.endTime}</span>
                            </div>
                            <div className="date-item view-PM-border-style" style={{ width: "45%" }}>
                                <label htmlFor="">Location</label>    <span>{viewdata?.meetingLocation?.location}</span>
                            </div>

                        </td>
                    </tr>

                    {!(stripHtmlTags(viewdata?.meetingAgenda)?.length === 0 || viewdata?.meetingAgenda?.length === 0) ?

                        <tr className='third-row row' style={{ minHeight: '5vh' }}>
                            <td className='left-column' style={{ verticalAlign: 'top', height: '6vh', paddingTop: "2px" }}>
                                <p style={{ margin: "3px 0" }}>Agenda</p>
                            </td>
                            <td className='right-column agenda-row' style={{ width: '100%', paddingTop: "9px" }}>
                                <div id="VPM_agendadiv" dangerouslySetInnerHTML={{ __html: viewdata?.meetingAgenda }} style={{ width: '95%', fontSize: '13px', marginLeft: '0px', padding: '0px 6px 2px 6px', color: 'black' }}>
                                </div>
                            </td>
                        </tr>
                        :
                        <tr className='third-row row' style={{ minHeight: '5vh' }}>
                            <td className='left-column' style={{ verticalAlign: 'top', height: '6vh', paddingTop: "2px" }}>
                                <p style={{ margin: "3px 0" }}>Agenda</p>
                            </td>
                            <td className='right-column agenda-row' style={{ width: '100%', paddingTop: "9px" }}>
                                <div id="VPM_agendadiv" style={{ width: '95%', fontSize: '13px', marginLeft: '0px', padding: '0px 6px 2px 6px', color: 'black' }}>Not Available</div>
                            </td>
                        </tr>
                    }

                    <tr className='fourth-row row' style={{ minHeight: '5.5vh', marginBottom: "5px" }}>
                        <td className='left-column' style={{ verticalAlign: 'top', height: '6.5vh', padding: " 5px 0px 0px 4px" }}><p>Attendees</p></td>
                        <td className='VPM-email-details' style={{ padding: '6px 4px 0px 4px', color: 'black' }} >
                            {emailDetails?.AttendeesList}
                        </td>
                    </tr>  {emailDetails?.ApologiesList && <tr className='fifth-row row' style={{ minHeight: '6vh', marginBottom: "5px" }}>
                        <td className='left-column' style={{ verticalAlign: 'top', height: '6vh', padding: '2px 0px 0px 4px' }}><p>Apologies</p></td>
                        <td className='VPM-email-details' style={{ padding: '0px 4px', color: 'black' }}>
                            <div style={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>{emailDetails?.ApologiesList}</div>
                        </td>
                    </tr>}
                    <tr className='sixth-row row' style={{ minHeight: '6vh' }}>

                        <td className='left-column' style={{ verticalAlign: 'top', height: '6vh' }}>

                            <p style={{ margin: "3px 0", display: 'flex', alignItems: 'flex-start', color: 'var(--rnt-bg)', fontSize: '13px', borderLeft: '2px solid #00adee', background: 'transparent linear-gradient(90deg, #E6F9FF 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box' }}>
                                Discussion Summary
                            </p>

                        </td>
                        <td className='right-column Discussion-row' style={{ width: '100%', minHeight: " 6vh", color: 'black', paddingTop: "7px" }}>
                            {
                                <div id="VPM_summarydiv" dangerouslySetInnerHTML={{ __html: viewdata?.meetingSummary }} style={{ width: '95', fontSize: '13px', marginLeft: '0px', padding: '0px 6px 5px 5px' }}>
                                </div>
                            }


                        </td>
                    </tr>
                    <tr className='seventh-row row' style={{ minHeight: '6vh' }}>
                        <td className='left-column' style={{ verticalAlign: 'top', height: '6vh', padding: '4px 0px 0px 4px' }}><p>Action Items</p></td>
                        <td className='action-row' style={{ minHeight: '6vh', paddingTop: '4px' }}>
                            <table className='action-row-table' border="1" style={{ width: '100%', border: "none" }}>
                                <tr className='action-row-tr' style={{ borderTop: "none", borderLeft: 'none', borderRight: 'none', backgroundColor: '#7DD4F5', color: 'white' }}>
                                    <th className='action-item seventh-row-item-design' style={{ textAlign: "left", paddingLeft: "5px", fontSize: " 15px", width: "5%", }}>Sr.no</th>
                                    <th className='action-item seventh-row-item-design' style={{ textAlign: "left", paddingLeft: "5px", fontSize: " 15px", width: "55%", }}>Task </th>
                                    <th className='action-item seventh-row-item-design' style={{ textAlign: "left", paddingLeft: "5px", fontSize: " 15px", width: "17%", }}>Owner</th>
                                    <th className='action-item seventh-row-item-design' style={{ textAlign: "left", paddingLeft: "5px", fontSize: " 15px", width: "10%", }}>ETA</th>
                                    <th className='action-item ' style={{ width: "11%", textAlign: "left", paddingLeft: "5px", fontSize: " 15px" }}>Closing Date</th>
                                </tr>
                                <tbody style={{ overflowY: 'scroll', }}>
                                    {actions.length === 0 && (
                                        <tr>
                                            <td colSpan="5" style={{ textAlign: 'center' }}>No action items available</td>
                                        </tr>
                                    )}
                                    {
                                        actions.map((item, index) => {
                                            return (
                                                <tr className='action-row-tr-data ' style={{ borderTop: "none", borderLeft: 'none', borderRight: 'none', borderBottom: actions.length - 1 == index ? 'none' : "" }}>
                                                    <td className='seventh-row-data' style={{ textAlign: "left" }}><p style={{ textAlign: "right", paddingRight: '8px' }}>{index + 1} </p></td>
                                                    <td className='seventh-row-data' style={{ textAlign: "left", paddingLeft: '0px' }}>
                                                        <p dangerouslySetInnerHTML={{ __html: transformText(item.taskName) }} />
                                                    </td>
                                                    <td className='seventh-row-data' style={{ textAlign: "left", paddingaLeft: '0px' }}><p>{item.assignedTo.fullName}</p></td>
                                                    <td className='seventh-row-data' style={{ textAlign: "left", paddingaLeft: '0px' }}><p>{item.etaDate && moment(`${item.etaDate[0]}-${item.etaDate[1]}-${item.etaDate[2]}`).format('DD/MM/YYYY')}</p></td>
                                                    <td><p style={{ textAlign: "left", paddingaLeft: '0px' }}>
                                                        {item?.closingDate ? moment(`${item?.closingDate[0]}-${item?.closingDate[1]}-${item?.closingDate[2]}`).format('DD/MM/YYYY') : "NA"}</p></td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>

                            </table>
                        </td>
                    </tr>
                </table>



            </div>
            <FailModal
                openFailModal={sessionExpiredModal}
                setOpenFailModal={setSessionExpiredModal}
                failMessage={failMessage}
                setFailMessage={setFailMessage}
                recallFunctionOnOk={()=>handleSessionExpClose(navigate,setActive)}
                recallFunctiononClose={()=>handleSessionExpClose(navigate,setActive)}
            />
        </div >
    )
}

export default ViewPastMeetings